import React from 'react';
import BottomActionBar from '../../../../../components/BottomActionBar';

interface SummaryBottomProps {
  loading: boolean;
  hasProducts: boolean;
  handlePrevious: () => void;
  handleNext: () => void;
}

export const SummaryBottomSearchItem = ({
  loading,
  hasProducts,
  handlePrevious,
  handleNext
}: SummaryBottomProps) => {
  if (loading && !hasProducts) {
    return null;
  }

  return (
    <BottomActionBar
      previousBtn={{
        fn: handlePrevious,
        name: 'previousBtn',
        text: 'Voltar',
        disabled: loading
      }}
      nextBtn={{
        fn: handleNext,
        name: 'nextBtn',
        text: 'Avançar para o carrinho',
        disabled: loading || !hasProducts
      }}
    ></BottomActionBar>
  );
};
